module.exports = "pegasus/assets/blocks/image-1-theme3.png";